/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]     ngui-auto-complete .ngui-auto-complete ul{max-height:400px;overflow-y:auto;background:#fff!important}[_nghost-%COMP%]     ngui-auto-complete .ngui-auto-complete ul li{text-align:left;cursor:pointer;line-height:30px}[_nghost-%COMP%]     ngui-auto-complete .ngui-auto-complete ul li:hover{background:#d3d3d3}"];
export { styles as styles };
